/**
 * MSW inline responses for /apollo/mobile-devices/*.
 *
 * The Device Registrations panel on the Company → Users tab fetches the
 * company's registered mobile devices. There is no fixture JSON for this
 * endpoint, so a representative list is served here so the Users tab story
 * snapshot renders a populated table instead of an empty state.
 *
 * send-test-notification returns no body (void) — an empty object keeps MSW
 * happy for the mutation path.
 */
export const MOBILE_DEVICES_INLINE_RESPONSES: Record<
  string,
  Record<string, unknown> | unknown[]
> = {
  "/apollo/mobile-devices/list-for-company": [
    {
      mobileDeviceId: "md-1111-0000-0000-000000000001",
      userId: "22222222-2222-2222-2222-222222222222",
      platform: "ios",
      environment: "production",
      deviceName: "Warehouse iPhone",
      deviceModel: "iPhone 16 Pro",
      osVersion: "iOS 26.3",
      appVersion: "1.4.0",
      lastRegisteredAt: "2026-06-20T15:30:00Z",
    },
    {
      mobileDeviceId: "md-1111-0000-0000-000000000002",
      userId: "33333333-3333-3333-3333-333333333333",
      platform: "ios",
      environment: "sandbox",
      deviceName: "Dispatch iPad",
      deviceModel: "iPad Pro 11",
      osVersion: "iPadOS 26.1",
      appVersion: "1.3.2",
      lastRegisteredAt: "2026-06-18T09:05:00Z",
    },
  ],
  "/apollo/mobile-devices/send-test-notification": {},
};
